/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcfOauthAppAvailable } from './vcfOauthAppAvailable';
import { ServiceCspUnGated } from './serviceCspUnGated';
import { VmcOauthAppAvailable } from './vmcOauthAppAvailable';
import { VmcProperties } from './vmcProperties';
import { OperatorSeedOAuthAppProperties } from './operatorSeedOAuthAppProperties';
import { ServiceVcdsRestricted } from './serviceVcdsRestricted';


export interface VcdsOrgProperties { 
    org_id: string;
    org_name?: string;
    org_short_id?: string;
    org_type?: string;
    org_type_overridden?: boolean;
    erp_id?: string;
    date_org_found?: Date;
    date_org_properties_updated?: Date;
    date_org_sellers_updated?: Date;
    date_org_type_updated?: Date;
    csp_ungated?: ServiceCspUnGated;
    si_billing_enabled?: boolean;
    vcds_restricted?: ServiceVcdsRestricted;
    vcf_oauth_app_available?: VcfOauthAppAvailable;
    vmc_oauth_app_available?: VmcOauthAppAvailable;
    vmc_properties?: VmcProperties;
    vmc_ungated?: boolean;
    vcds_md5_hash?: string;
    seed_oauth?: OperatorSeedOAuthAppProperties;
}

